import { useEffect, useRef } from "react";

import { useDispatch } from "react-redux";

import ReconnectingWebSocket from "reconnecting-websocket";
import {
  setStatus,
  receiveMessage,
  clearData,
  setWSReference,
  contestReceiveMessage,
} from "../utils/live/actions";
import { AppState } from "react-native";
import {
  setAppPaused,
  setAppResumed,
} from "../utils/commonredux/commonRedux.action";
import {
  updateEventDetails,
  updateEventTimeSeries,
} from "../screens/event/redux/events.actions";
import {
  updateLiquidity,
  updatePortfolio,
} from "../screens/portfolio/redux/portfolio.action";
import { useInitialiseSocketConnection } from "./initialiseSocketConnection";
import { REACT_APP_ENV } from "../../index";

export const wsUrl =
  REACT_APP_ENV === "prod"
    ? "wss://web.tradexapp.co/ws/price-ticker/"
    : REACT_APP_ENV === "staging"
    ? "wss://devweb.theox.co/ws/price-ticker/"
    : "wss://devweb.theox.co/ws/price-ticker/";

// let socket = new WebSocket(wsUrl);
// let id;
export function useWebSocket(isAppLogin) {
  const timerId = useRef();
  const socket = useRef();
  const dispatch = useDispatch();
  const appState = useRef(AppState.currentState);

  useInitialiseSocketConnection(socket.current, isAppLogin);

  const ping = () => {
    try {
      if (
        socket?.current?.readyState === 1 &&
        typeof socket?.current?.send === "function"
      ) {
        socket.current.send("ping");
      }
    } catch (e) {}
  };
  let a = 100;
  const updateSocketStatus = (event) => {
    if (event.type === "open") {
      timerId.current = setInterval(ping, 10000 * 10);
    } else {
      if (timerId.current) {
        clearInterval(timerId.current);
      }
    }
    if (a === 100 || a !== socket.current.readyState) {
      a = socket.current.readyState;
      dispatch(setStatus(socket.current.readyState));
    }
  };
  const dispatchReceiveMessage = (event) => {
    try {
      const data = JSON.parse(event.data);
      switch (true) {
        case data?.[0]?.channel === "price-ticks" ||
          data?.[0]?.channel === "portfolio-im-fixed" ||
          data?.[0]?.channel === "portfolio-im-variable":
          dispatch(receiveMessage(data));
          break;

        case data?.[0]?.channel === "fantasy-price-ticks":
          dispatch(contestReceiveMessage(data));
          break;
        case data?.channel === "probe-detail" ||
          data?.channel === "fantasy-probe-detail":
          dispatch(
            updateEventDetails(data, data?.channel === "fantasy-probe-detail")
          );
          break;
        case data?.channel === "probe-time-series" ||
          data?.channel === "fantasy-probe-time-series":
          dispatch(updateEventTimeSeries(data));
          break;
        case data?.channel === "private-portfolio" ||
          data?.channel === "fantasy-private-portfolio":
          dispatch(
            updatePortfolio(data, data?.channel === "fantasy-private-portfolio")
          );
          break;
        case data?.channel === "private-liquidity":
          dispatch(updateLiquidity(data));
          break;
      }
    } catch (e) {
      // dispatch(receiveMessage(event.data))
    }
  };
  const appPauseHandler = () => {
    if (socket?.current?.close) {
      socket.current.close();
    }
    dispatch(setAppPaused());
  };
  const appResumeHandler = () => {
    if (socket?.current?.reconnect) {
      socket.current.reconnect();
    }
    dispatch(setAppResumed());
  };

  useEffect(() => {
    const subscription = AppState.addEventListener("change", (nextAppState) => {
      if (
        appState.current.match(/inactive|background/) &&
        nextAppState === "active"
      ) {
        appResumeHandler();
      } else if (
        appState.current === "active" &&
        nextAppState === "background"
      ) {
        appPauseHandler();
      }

      appState.current = nextAppState;
    });

    return () => {
      subscription.remove();
    };
  }, []);

  useEffect(() => {
    // console.log("CALLING OF USE EFFECT IN USE WEBSOCKET")

    socket.current = new ReconnectingWebSocket(wsUrl, [], {
      connectionTimeout: 1000,
      maxRetries: 10,
      debug: false,
    });
    dispatch(setWSReference(socket.current));

    socket.current.onopen = (e) => {
      updateSocketStatus(e);
    };
    socket.current.onmessage = (evt) => {
      dispatchReceiveMessage(evt);
    };
    socket.current.onclose = (e) => {
      updateSocketStatus(e);
    };
    socket.current.onerror = (e) => {
      updateSocketStatus(e);
    };
    return () => {};
  }, []);
  return socket.current;
}
